module.exports = __webpack_public_path__ + "static/headling_epic_chat_stories.4a7eb761.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/headling_epic_chat_stories.png
// module id = 1421
// module chunks = 168707334958949